import Chat20 from '@carbon/icons-react/es/chat/20';
import { Tooltip } from 'antd';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useRouteMatch } from 'react-router';
import { FileAttachment } from 'api/attachments';
import { AttachmentType } from 'api/attachments/types';
import { ReactComponent as MergeIcon } from 'assets/svgs/merge.svg';
import { ReactComponent as SideBySideIcon } from 'assets/svgs/side_by_side.svg';
import { RoutePaths } from 'constant';
import { TaskName } from '../task-name';
import {
  Wrapper,
  NameWrapper,
  AttachmentName,
  ActionsWrapper,
  ActionsButtonWrapper,
  ActionButtonActiveWrapper,
  TaskNameWrapper,
} from './preview-header-style-components';

interface Props {
  latestVersionId: number;
  leftAttachmentId: number;
  rightAttachmentId: number;
  isChatSectionComparisonVisible: boolean;
  setChatSectionComparisonVisiblityToggle: () => void;
  latestVersion: FileAttachment;
  onOpenParentTask: () => void;
}

export const ComparisionPreviewHeader: React.FC<Props> = ({
  latestVersionId,
  leftAttachmentId,
  rightAttachmentId,
  isChatSectionComparisonVisible,
  setChatSectionComparisonVisiblityToggle,
  latestVersion,
  onOpenParentTask,
}) => {
  const history = useHistory();
  const isSideBySideComparison = useRouteMatch([
    RoutePaths.attachmentWorkspaceSideBySide,
  ]);
  const isOverlayComparison = useRouteMatch([
    RoutePaths.attachmentWorkspaceOverlay,
  ]);

  const onSideBySideClick = useCallback(() => {
    history.replace(
      RoutePaths.attachmentWorkspaceSideBySide
        .replace(':attachmentId', leftAttachmentId.toString())
        .replace(':compareAttachmentId', rightAttachmentId.toString()),
    );
  }, [history, leftAttachmentId, rightAttachmentId]);

  const onOverlayClick = useCallback(() => {
    history.replace(
      RoutePaths.attachmentWorkspaceOverlay
        .replace(':attachmentId', leftAttachmentId.toString())
        .replace(':compareAttachmentId', rightAttachmentId.toString()),
    );
  }, [history, leftAttachmentId, rightAttachmentId]);

  const onExitComparision = useCallback(() => {
    history.replace(
      RoutePaths.attachmentWorkspace.replace(
        ':attachmentId',
        latestVersionId.toString(),
      ),
    );
  }, [history, latestVersionId]);

  return (
    <Wrapper>
      <NameWrapper>
        <AttachmentName>
          <FormattedMessage id="image_preview.compare.version.comparison" />
        </AttachmentName>

        {latestVersion?.projectId &&
          latestVersion?.sourceId &&
          latestVersion.sourceType === AttachmentType.Task && (
            <TaskNameWrapper title="Task Name" onClick={onOpenParentTask}>
              <TaskName
                projectId={latestVersion.projectId}
                taskId={latestVersion.sourceId}
              />
            </TaskNameWrapper>
          )}
      </NameWrapper>
      <ActionsWrapper>
        <>
          <Tooltip
            title={<FormattedMessage id="image_preview.compare.side_by_side" />}
          >
            <ActionButtonActiveWrapper
              active={!!isSideBySideComparison}
              onClick={onSideBySideClick}
            >
              <SideBySideIcon />
            </ActionButtonActiveWrapper>
          </Tooltip>
          <Tooltip
            title={<FormattedMessage id="image_preview.compare.overlay" />}
          >
            <ActionButtonActiveWrapper
              active={!!isOverlayComparison}
              onClick={onOverlayClick}
            >
              <MergeIcon />
            </ActionButtonActiveWrapper>
          </Tooltip>
        </>

        <Tooltip
          title={<FormattedMessage id="image_preview.show_hide_comments" />}
        >
          <ActionButtonActiveWrapper
            active={isChatSectionComparisonVisible}
            onClick={setChatSectionComparisonVisiblityToggle}
          >
            <Chat20 />
          </ActionButtonActiveWrapper>
        </Tooltip>

        <Tooltip
          title={<FormattedMessage id="image_preview.exit.comaprision" />}
        >
          <ActionsButtonWrapper onClick={onExitComparision}>
            <FormattedMessage id="image_preview.exit.comaprision" />
          </ActionsButtonWrapper>
        </Tooltip>
      </ActionsWrapper>
    </Wrapper>
  );
};
